import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useTranslation } from "react-i18next";

const EditableSectionModal = ({
  show,
  onClose,
  onSave,
  initialContent,
  label,
}) => {
  const { t } = useTranslation();
  const [tempContent, setTempContent] = useState("");

  useEffect(() => {
    setTempContent(initialContent);
  }, [initialContent]);

  const handleSave = () => {
    const cleaned = tempContent
      .replace(/<p>/g, "")
      .replace(/<\/p>/g, "<br/>")
      .replace(/<br>\s*/g, "<br/>")
      .replace(/(<br\/>\s*)+$/, "")
      .trim();

    onSave(cleaned);
    onClose();
  };

  const handleCancel = () => {
    setTempContent(initialContent);
    onClose();
  };

  return (
    <Modal show={show} size="lg" onHide={handleCancel}>
      <Modal.Header closeButton>
        <Modal.Title>{label||t("editSection")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="editableContent">
            <ReactQuill
              theme="snow"
              value={tempContent}
              onChange={setTempContent}
              placeholder={t("editSectionPlaceholder")}
              style={{
                height: "200px",
                marginBottom: "50px",
                fontSize: "16px",
              }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button size="sm" variant="secondary" onClick={handleCancel}>
          {t("close")}
        </Button>
        <Button size="sm" variant="primary" onClick={handleSave}>
          {t("save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditableSectionModal;
